import React from 'react';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/Components/ui/sidebar';
import { Sidebar } from './Sidebar';
import { cn } from '@/lib/utils';
// AI Assistant — mounted once here so the dock exists on every employer page
// (G1, COPILOT_GLOBAL_PLAN.md §2). Pages publish their on-screen context with
// `useAssistantPage()`; the dock renders nothing until /api/copilot/status
// says enabled:true.
import { CopilotProvider } from '../Applications/copilot/CopilotContext';
import ApplicationsCopilot from '../Applications/copilot/ApplicationsCopilot';

/**
 * Layout component for employer pages with Sidebar
 * Automatically handles sidebar positioning and main content spacing
 *
 * Usage:
 * <EmployerLayout>
 *   <YourPageContent />
 * </EmployerLayout>
 */
export const EmployerLayout = ({
  children,
  className = '',
  contentClassName = '',
}) => {
  return (
    <SidebarProvider defaultOpen={true}>
      <CopilotProvider>
        <Sidebar />
        <SidebarInset
          className={cn(
            "w-full min-w-0 overflow-hidden min-h-screen bg-[#f8f9fa] pt-6 md:pt-8 lg:pt-10 pb-8 px-4 md:px-6",
            className
          )}
        >
          {/* Mobile: show a trigger to open the off-canvas sidebar */}
          <div className="md:hidden flex items-center gap-2 mb-4">
            <SidebarTrigger />
            <span className="text-sm font-semibold text-muted-foreground">
              Menu
            </span>
          </div>
          <div
            className={cn(
              "w-full h-full max-w-6xl mx-auto min-w-0",
              contentClassName
            )}
          >
            {children}
          </div>
        </SidebarInset>
        {/* AI Assistant dock (floating; renders nothing unless enabled server-side) */}
        <ApplicationsCopilot />
      </CopilotProvider>
    </SidebarProvider>
  );
};
